import { registerReportPage, type ReportPageDefinition } from '@/features/reports'

const DISPLAY_VIDEO_360_PAGE = {
  routeName: 'DisplayVideo360',
  path: 'marketing-insights/search-marketing/display-video-360',
  layoutKey: 'DISPLAY_VIDEO_360',
  reportIds: [43],
  navKey: 'displayVideo360',
  titleKey: 'marketingInsights.displayVideo360.title',
} satisfies ReportPageDefinition

const SEARCH_ADS_EXCELLENCE_PAGE = {
  routeName: 'SearchAdsExcellence',
  path: 'marketing-insights/search-marketing/search-ads-excellence',
  layoutKey: 'SEARCH_ADS_EXCELLENCE',
  reportIds: [1, 5, 71],
  navKey: 'searchAdsExcellence',
  titleKey: 'marketingInsights.searchAdsExcellence.title',
} satisfies ReportPageDefinition

const PERFORMANCE_MAX_PAGE = {
  routeName: 'PerformanceMaxCampaigns',
  path: 'marketing-insights/performance-max-campaigns',
  layoutKey: 'PERFORMANCE_MAX_CAMPAIGNS',
  reportIds: [26, 13],
  queryReportIds: [26],
  recomIds: [26],
  navKey: 'performanceMax',
  titleKey: 'marketingInsights.performanceMax.title',
} satisfies ReportPageDefinition

const LANDING_PAGE = {
  routeName: 'LandingPage',
  path: 'marketing-insights/landing-page',
  layoutKey: 'LANDING_PAGE',
  reportIds: [22],
  navKey: 'landingPage',
  titleKey: 'marketingInsights.landingPage.title',
  isNotTab: true,
} satisfies ReportPageDefinition

const PLACEMENT_ANALYSIS_PAGE = {
  routeName: 'PlacementAnalysis',
  path: 'marketing-insights/placement-analysis',
  layoutKey: 'PLACEMENT_ANALYSIS',
  reportIds: [60, 26, 19, 45],
  queryReportIds: [60],
  recomIds: [60],
  navKey: 'placementAnalysis',
  titleKey: 'marketingInsights.placementAnalysis.title',
} satisfies ReportPageDefinition

export function registerMarketingInsightsPages(): () => void {
  const undos = [
    registerReportPage(DISPLAY_VIDEO_360_PAGE),
    registerReportPage(SEARCH_ADS_EXCELLENCE_PAGE),
    registerReportPage(PERFORMANCE_MAX_PAGE),
    registerReportPage(LANDING_PAGE),
    registerReportPage(PLACEMENT_ANALYSIS_PAGE),
  ]
  return () => {
    for (const undo of undos) undo()
  }
}
